export default __webpack_public_path__ + "static/media/image2.3f057670.jpg";